import * as React from "react";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "styled-components";
import Spinner from "components/common/Spinner";
import { Alert } from "components/bootstrap";
import fetch from "logic/rest/FetchProvider";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { qualifyUrl } from "util/URLUtils";
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-height: 200px;
`;
const buildBackendUrl = (stepId, eventId) => {
  const stepParam = `stepId=${stepId}`;
  const eventParam = eventId ? `&eventId=${eventId}` : "";
  const params = stepParam + eventParam;
  return qualifyUrl(EnterpriseApiRoutes.SecurityApp.EventProcedures.steps.executeAction(params).url);
};
const ExecuteEventProcedureActionPage = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);
  const [status, setStatus] = useState("idle");
  const stepId = searchParams.get("stepId");
  const eventId = searchParams.get("eventId");
  useEffect(() => {
    let cancelled = false;
    if (!stepId) {
      setError("The event procedure link is missing the required step identifier.");
      return void 0;
    }
    setStatus("executing");
    fetch("GET", buildBackendUrl(stepId, eventId)).then((response) => {
      if (cancelled) {
        return;
      }
      const redirectUri = response == null ? void 0 : response.redirect_uri;
      if (!redirectUri) {
        setError("The event procedure action responded without a redirect location.");
        setStatus("idle");
        return;
      }
      setStatus("redirecting");
      window.location.replace(redirectUri);
    }).catch((executionError) => {
      var _a;
      if (cancelled) {
        return;
      }
      const message = ((_a = executionError == null ? void 0 : executionError.additional) == null ? void 0 : _a.message) || (executionError == null ? void 0 : executionError.message) || "Failed to execute the event procedure action.";
      setError(message);
      setStatus("idle");
    });
    return () => {
      cancelled = true;
    };
  }, [stepId, eventId]);
  if (error) {
    return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, error));
  }
  const spinnerText = status === "redirecting" ? "Redirecting to the target..." : "Executing event procedure action...";
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Spinner, { text: spinnerText, delay: 0 }));
};
export default ExecuteEventProcedureActionPage;
